<template>
  <div
    :class="['oap-findation-wrapper', { 'oap-findation-wrapper--standalone': isStandalonePage }]"
  >
    <div id="findation-widget-button" ref="findationButton"></div>
    <LoadScript
      v-if="shouldLoadScript"
      :attributes="{ type: 'text/javascript' }"
      src="https://assets.findation.com/javascripts/w-adv-13.min.js"
      name="findation"
      @loaded="initWidget"
    >
    </LoadScript>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import LoadScript from '@Foundation/loadscript/loadscript.vue';
import { AnalyticsHandler, intersectionViewportObserver } from '@Foundation';

const props = defineProps({
  widgetKey: { type: String, required: true },
  productApiUrl: { type: String, required: true, default: '' },
  locationOrigin: { type: String, default: '' },
  isStandalonePage: { type: Boolean, default: false },
  searchSetId: { type: String, default: '' },
  analytics: { type: Object, default: () => {} },
});

const findationButton = ref(null);
let shouldLoadScript = ref(false);
let productInfo = ref('');

onMounted(() => {
  intersectionViewportObserver(findationButton.value).then(() => {
    shouldLoadScript.value = true;
  });

  productInfo.value = props.isStandalonePage
    ? 'undefined'
    : `${props.analytics?.productName}::${props.analytics?.productId}`;
});

function initWidget() {
  window.Findation = window.Findation || {};

  const searchSetLookupReference = props.searchSetId;

  Findation.init(findationButton.value, props.widgetKey, {
    buttonWidth: '100%',
    buttonHeight: '40px',
    searchSetLookupReference,
  });

  Findation.widgetEmbedded = () => {
    if (props.isStandalonePage) Findation.openWidget();

    AnalyticsHandler.getAnalyticsHandler().push({
      type: 'nonInteractiveEvent',
      event_name: 'findation_widget_impression',
      category: 'findation',
      action: 'widget',
      label: 'impression',
    });
  };

  Findation.onActionReceived = (payload) => {
    const eventName = payload.split('::')[0];
    const payloadData = payload.split('::')[1];

    if (eventName === 'triggerRedirect') {
      const url = `${props.productApiUrl}?ean=${payloadData}`;

      fetch(url)
        .then((response) => response.json())
        .then((jsonData) => {
          if (jsonData.Url) window.location.assign(jsonData.Url);

          if (payloadData) {
            AnalyticsHandler.getAnalyticsHandler().push({
              type: 'userActionEvent',
              event_name: 'buy_now',
              category: 'Ecommerce',
              action: 'click to buy',
              label: `${jsonData.Name}::${payloadData}::${jsonData.ShadeName}`,
              product_info: productInfo.value,
              event_detail: 'findation',
            });
          }
        });
    } else if (eventName === 'goTo') {
      const locationOrigin = props.locationOrigin ? props.locationOrigin : window.location.origin;

      if (payloadData) window.location.assign(`${locationOrigin}${payloadData}`);
    }
  };

  Findation.widgetDidOpen = () => {
    getAnalytics('opened', props.analytics?.mainFindationButton);
  };

  Findation.onSearchComplete = () => {
    getAnalytics('shades entered', props.analytics?.submitButton);
  };
}

function getAnalytics(label, ctaName) {
  if (props.analytics) {
    AnalyticsHandler.getAnalyticsHandler().push({
      type: 'userActionEvent',
      event_name: 'findation_interaction',
      category: '__pageCategory__::findation',
      action: 'widget',
      label,
      click_action: label,
      cta_name: ctaName,
      product_info: productInfo.value,
      service_name: 'findation',
    });
  }
}
</script>
